export const setNavbarExpanded = (data) => ({
	type: 'SET_NAVBAR',
	payload: data,
});
export const setCampaignDetails = (data) => ({
	type: 'SET_CAMPAIGN',
	payload: data,
});
export const setUser = (data) => ({
	type: 'SET_USER',
	payload: data,
});

export const setCompany = (data) => ({
	type: 'SET_COMPANY',
	payload: data,
});

export const setProfile = (data) => ({
    type: 'SET_PROFILE',
    payload: data, // { name, imgUrl }
});

export const setReportsCallDetails = (data) => ({
	type: 'SET_REPORTS_CALL_DETAILS',
	payload: data,
});